import {Box} from "@mui/material";

export default function AdminAccessForbidden() {
	return (
		<Box sx={{p: 2}}>Access Forbidden</Box>
	)
}
